(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Function to update pricing widget
  function updatePricingWidget(months) {
    const gummiesPerDay = 4;
    const basePrice = 50.00;
    const baseGummyCount = gummiesPerDay * 30;
    const basePricePerServing = basePrice / 30;
    
    // Calculate discount based on months
    const discount = (months - 1) * 0.12;
    const totalGummies = baseGummyCount * months;
    const discountedPricePerServing = basePricePerServing * (1 - discount);
    
    // Update the display
    document.querySelector('.price').textContent = 
      `$${discountedPricePerServing.toFixed(2)}`;
    document.querySelector('.quantity').textContent = 
      totalGummies;
    document.querySelector('.duration').textContent = 
      `${months * 30}-Day`;
  }

  // Listen for variant changes
  document.addEventListener('change', function(event) {
    if (event.target.matches('input[type="radio"][name*="Supply"]')) {
      const value = event.target.value;
      const months = parseInt(value.split('-')[0]);
      if (!isNaN(months)) {
        updatePricingWidget(months);
      }
    }
  });

  // Also listen for clicks on the variant labels
  document.addEventListener('click', function(event) {
    const label = event.target.closest('label[for*="Supply"]');
    if (label) {
      const input = document.getElementById(label.getAttribute('for'));
      if (input) {
        const value = input.value;
        const months = parseInt(value.split('-')[0]);
        if (!isNaN(months)) {
          updatePricingWidget(months);
        }
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-options"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const subscriptionOptions = document.querySelectorAll('input[name="subscription_option"]');

  function updatePricingWidget(months, discountedPrice) {
    const gummiesPerDay = 4;
    const baseGummyCount = gummiesPerDay * 30;
    const totalGummies = baseGummyCount * months;

    // Find the pricing widget elements
    const priceElement = document.querySelector('.price');
    const quantityElement = document.querySelector('.quantity');
    const durationElement = document.querySelector('.duration');

    // Update the display if elements exist
    if (priceElement) {
      priceElement.textContent = `$${parseFloat(discountedPrice).toFixed(2)}`;
    }
    if (quantityElement) {
      quantityElement.textContent = totalGummies;
    }
    if (durationElement) {
      durationElement.textContent = `${months * 30}-Day`;
    }
  }

  // Add change event listener to radio buttons
  subscriptionOptions.forEach(option => {
    option.addEventListener('change', function() {
      const months = parseInt(this.dataset.months);
      const discountedPrice = parseFloat(this.dataset.discountedPrice);

      if (!isNaN(months) && !isNaN(discountedPrice)) {
        updatePricingWidget(months, discountedPrice);
      }
    });
  });

  // Trigger update for the initially selected option
  const selectedOption = document.querySelector('input[name="subscription_option"]:checked');
  if (selectedOption) {
    const months = parseInt(selectedOption.dataset.months);
    const discountedPrice = parseFloat(selectedOption.dataset.discountedPrice);

    if (!isNaN(months) && !isNaN(discountedPrice)) {
      updatePricingWidget(months, discountedPrice);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscriptions-options"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // We'll add Recharge integration code here later
  });

  } catch(e) { console.error(e); }
})();
})();
